<div class="contactPage">
   <div class="pageBanner contacts"></div>
   <div class="mapBox">
      <!-- <agm-map
         [latitude]="mapSettings?.lat"
         [longitude]="mapSettings?.lng"
         [scrollwheel]="mapSettings?.scrollWheel"
         [zoom]="mapSettings?.zoom"
         [zoomControlOptions]="mapSettings?.zoomControlOptions"
         [streetViewControl]="mapSettings?.streetViewControl"
         [styles]="mapSettings?.style" [controlSize]="25" [showDefaultInfoWindow]="false">
      </agm-map> -->

      <div class="contentBox">
         <div class="locationsSec">
            <ul class="locations normal flex align-top">
               <li>
                  <div class="icon locationIcon wow fadeInUp"
                       data-wow-duration="500ms" data-wow-delay="0ms">
                     <img src="assets/images/singapore-grey.png" alt="">
                  </div>
                  <div class="locationDetails">
                     <div class="countryName proximaNovaSb font-17 highlight-color wow fadeInUp"
                          data-wow-duration="500ms" data-wow-delay="100ms">SINGAPORE</div>
                     <div class="address proximaNovaLt wow fadeInUp"
                          data-wow-duration="500ms" data-wow-delay="200ms">
                        80 Marine Parade Rd, <br>
                        <span>Singapore 449269</span>
                     </div>
                     <div class="phoneEmail wow fadeInUp"
                          data-wow-duration="500ms" data-wow-delay="200ms">
                        Ph: +6563441242<br>
                        <span>Email: mh@missionholdings.com</span>
                     </div>
                     <div class="mapButton proximaNovaSb wow fadeInUp"
                          data-wow-duration="500ms" data-wow-delay="250ms">Map</div>
                  </div>
               </li>
               <li>
                  <div class="icon locationIcon wow fadeInUp"
                       data-wow-duration="500ms" data-wow-delay="0ms">
                     <img src="assets/images/sanFrancisco-grey.png" alt="">
                  </div>
                  <div class="locationDetails">
                     <div class="countryName proximaNovaSb font-17 highlight-color wow fadeInUp"
                          data-wow-duration="500ms" data-wow-delay="100ms">SAN FRANCISCO</div>
                     <div class="address proximaNovaLt wow fadeInUp"
                          data-wow-duration="500ms" data-wow-delay="200ms">
                        80 Marine Parade Rd, <br>
                        <span>Singapore 449269</span>
                     </div>
                     <div class="phoneEmail wow fadeInUp"
                          data-wow-duration="500ms" data-wow-delay="200ms">
                        Ph: +6563441242<br>
                        <span>Email: mh@missionholdings.com</span>
                     </div>
                     <div class="mapButton proximaNovaSb wow fadeInUp"
                          data-wow-duration="500ms" data-wow-delay="250ms">Map</div>
                  </div>
               </li>
               <li>
                  <div class="icon locationIcon wow fadeInUp"
                       data-wow-duration="500ms" data-wow-delay="0ms">
                     <img src="assets/images/india-grey.png" alt="">
                  </div>
                  <div class="locationDetails">
                     <div class="countryName proximaNovaSb font-17 highlight-color wow fadeInUp"
                          data-wow-duration="500ms" data-wow-delay="100ms">INDIA</div>
                     <div class="address proximaNovaLt wow fadeInUp"
                          data-wow-duration="500ms" data-wow-delay="200ms">
                        80 Marine Parade Rd, <br>
                        <span>Singapore 449269</span>
                     </div>
                     <div class="phoneEmail wow fadeInUp"
                          data-wow-duration="500ms" data-wow-delay="200ms">
                        Ph: +6563441242<br>
                        <span>Email: mh@missionholdings.com</span>
                     </div>
                     <div class="mapButton proximaNovaSb wow fadeInUp"
                          data-wow-duration="500ms" data-wow-delay="250ms">Map</div>
                  </div>
               </li>
            </ul>
            <div class="emailSec">
               <div class="email proximaNovaLt border-top wow fadeInUp"
                    data-wow-duration="500ms" data-wow-delay="00ms">
                  Email: mh@missionholdings.com
               </div>
            </div>

         </div>
      </div>
   </div>
</div>
